import AlertTriangle from '@crehana/compass.icons.fill/AlertTriangle';
import CheckmarkCircle from '@crehana/compass.icons.fill/CheckmarkCircle';
import CloseCircle from '@crehana/compass.icons.fill/CloseCircle';
import Info from '@crehana/compass.icons.fill/Info';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var iconClassNames = {
  informative: 'tw-text-info-500 dark:tw-text-info-300',
  success: 'tw-text-success-500 dark:tw-text-success-400',
  warning: 'tw-text-on-hold-500 dark:tw-text-on-hold-300',
  error: 'tw-text-alert-500 dark:tw-text-alert-300'
};
export var CalloutIcon = function CalloutIcon(_ref) {
  var type = _ref.type;
  var icon = {
    informative: /*#__PURE__*/_jsx(Info, {
      size: 20,
      className: iconClassNames[type]
    }),
    success: /*#__PURE__*/_jsx(CheckmarkCircle, {
      size: 20,
      className: iconClassNames[type]
    }),
    warning: /*#__PURE__*/_jsx(AlertTriangle, {
      size: 20,
      className: iconClassNames[type]
    }),
    error: /*#__PURE__*/_jsx(CloseCircle, {
      size: 20,
      className: iconClassNames[type]
    })
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: icon[type]
  });
};